import { Box, Link, Stack, styled, Typography } from "@mui/material"
import type React from "react"
import { formatLocalDateTime } from "../../utils/dates"
import { extraColors } from "../../utils/theme"

const MemberCard = styled(Box)(() => ({
  padding: 12,
  backgroundColor: "rgba(255,255,255,0.03)",
  borderRadius: "6px",
  border: `1px solid ${extraColors.translucent5}`,
  "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
}))

export interface GdeltMemberListItemProps {
  title: string
  sourceName?: string | null
  publishTime?: string | null
  url?: string | null
  onLinkClick?: React.MouseEventHandler<HTMLAnchorElement>
}

export const GdeltMemberListItem: React.FC<GdeltMemberListItemProps> = ({
  title,
  sourceName,
  publishTime,
  url,
  onLinkClick,
}) => {
  const content = (
    <>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          mb: 0.5,
          display: "block",
          lineHeight: 1.3,
        }}
      >
        {title.trim() || "Untitled"}
      </Typography>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
        <Typography variant="caption" sx={{ opacity: 0.4, fontSize: "0.6rem" }}>
          {sourceName || "Unknown"}
        </Typography>
        {publishTime && (
          <Typography
            variant="caption"
            sx={{
              color: extraColors.status.navyLight,
              fontWeight: 800,
              fontSize: "0.6rem",
            }}
          >
            {formatLocalDateTime(publishTime)}
          </Typography>
        )}
      </Stack>
    </>
  )

  return (
    <MemberCard>
      {url ? (
        <Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onLinkClick}
          sx={{
            display: "block",
            color: "inherit",
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          {content}
        </Link>
      ) : (
        content
      )}
    </MemberCard>
  )
}
